import React from 'react';
import useLocale from 'jsx/locale/useLocale';

const TOP_MENU = [
  {
    id: 0,
    text: 'Tilkynningar',
    url: '/',
    exact: false
  },
  {
    id: 1,
    text: 'Umsóknir',
    url: '/umsoknir',
    exact: false
  }
];

export default function useTopProducts() {
  const { t, locale } = useLocale();
  const products = React.useMemo(() => {
    return TOP_MENU.map(product => ({
      ...product,
      label: t(product.text) || product.text
    }));
  }, [t, locale]);
  return products;
}
